var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{staticClass:"aboutsNews",attrs:{"title":"讲师视频","visible":_vm.dialogVisible,"width":"50%","close-on-click-modal":false,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"prism-player",attrs:{"id":"prism-player"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }